import { LocationProvider, Router, Route } from 'preact-iso';
import { useEffect, useState } from 'preact/hooks';
import { api, type Me } from './lib/api.js';
import { BottomNav } from './components/BottomNav.js';
import { Week } from './screens/Week.js';
import { EventCreate } from './screens/EventCreate.js';
import { EventDetail } from './screens/EventDetail.js';
import { EventEdit } from './screens/EventEdit.js';
import { Inbox } from './screens/Inbox.js';
import { Settings } from './screens/Settings.js';

export function App() {
  const [me, setMe] = useState<Me | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api<Me>('/auth/me')
      .then(setMe)
      .catch(() => {
        // api() leitet bei 401 automatisch weiter
      })
      .finally(() => setLoading(false));
  }, []);

  if (loading) {
    return (
      <div class="screen" style={{ textAlign: 'center', paddingTop: '40vh' }}>
        <span class="spinner" />
      </div>
    );
  }
  if (!me) return null;

  return (
    <LocationProvider>
      <Router>
        <Route path="/" component={() => <Week me={me} />} />
        <Route path="/new" component={() => <EventCreate me={me} />} />
        <Route path="/event/:id" component={EventDetail} />
        <Route path="/event/:id/edit" component={EventEdit} />
        <Route path="/inbox" component={() => <Inbox me={me} />} />
        <Route path="/settings" component={() => <Settings me={me} onUpdate={setMe} />} />
      </Router>
      <BottomNav />
    </LocationProvider>
  );
}
